import React, { Component } from 'react'
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom"

import Navegacion from './navbar'
import Principal from './principal'
import Empresa from './empresa'
import Productos from './productos'
import Descargas from './descargas'
import InfoUsuario from './infoUsuario'

import NavegacionAdmin from './administracion/navbar'
import Administracion from './administracion/main'
import AdminEmpresa from './administracion/empresa'
import AdminProductos from './administracion/productos'
import AdminDescargas from './administracion/descargas'
import AdminUsuarios from './administracion/usuarios'
import Analytics from './administracion/analytics'

import Footer from './footer'
import Usuario from './utilitarios/usuario'
import firebase from 'firebase/app'

const usuario = new Usuario()

export default class Main extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: null,
            routesAdmin: <Route path="/admin" render={() => <Redirect to="/" />} />
        }
    }

    isAdmin() {
        const _this = this
        usuario.isUserAdmin(this.state.user).then(result => {
            if (result) {
                _this.setState({
                    routesAdmin:
                        <div>
                            <Route path="/admin" component={NavegacionAdmin} />
                            <Route exact path="/admin" component={Administracion} />
                            <Route exact path="/admin/empresa" component={AdminEmpresa} />
                            <Route exact path="/admin/productos" component={AdminProductos} />
                            <Route exact path="/admin/descargas" component={AdminDescargas} />
                            <Route exact path="/admin/usuarios" component={AdminUsuarios} />
                            <Route exact path="/admin/analytics" component={Analytics} />
                        </div>
                })

            } else {
                _this.setState({
                    routesAdmin: <Route path="/admin" render={() => <Redirect to="/" />} />
                })
            }
        })
    }

    componentDidMount() {
        const _this = this
        firebase.auth().onAuthStateChanged(function (user) {
            _this.setState({ user })
            _this.isAdmin()
        })
    }

    componentWillMount() {

    }


    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <main>
                        <Route path="/" component={Navegacion} />
                        <Route exact path="/" component={Principal} />
                        <Route exact path="/empresa" component={Empresa} />
                        <Route exact path="/productos" component={Productos} />
                        <Route exact path="/productos/:categoria" component={Productos} />
                        <Route exact path="/productos/search/:search" component={Productos} />
                        <Route exact path="/descargas" component={Descargas} />
                        <Route exact path="/usuario/:uid" component={InfoUsuario} />
                        {
                            this.state.routesAdmin
                        }
                    </main>
                </Switch>
                <footer>
                    <Footer />
                </footer>
            </BrowserRouter>
        )
    }

}
